<template>
  <div id="app">
    <h1 class="mb-4 animate__animated animate__backInDown">
      Welcome To My Page
    </h1>
    <div class="row intro">
      <div class="col-sm-7 col-md-8 col-lg-9 order-2 order-sm-1">
        <h4>
          Hi, there! My name is Mladen. I am a front-end developer who has been
          designing websites and apps using
          <strong
            >HTML, CSS, SCSS, Bootstrap, Bulma, JavaScript, Vue.js, Git, and Jira.</strong
          >
        </h4>
      </div>
      <div class="col-sm-5 col-md-4 col-lg-3 order-1 order-sm-2 my-3">
        <a
          href="https://www.linkedin.com/in/mladen-kova%C4%8Devi%C4%87-62b238a1/"
          target="_blank"
        >
          <img
            src="./assets/ProfilePicture.jpg"
            alt="profile picture"
            width="150px"
            height="auto"
            class="profile"
          />
        </a>
        <a
          href="https://www.linkedin.com/in/mladen-kova%C4%8Devi%C4%87-62b238a1/"
          target="_blank"
          class="social"
        >
          <img
            src="./assets/LinkedIn.png"
            alt="linkedin icon"
            width="auto"
            height="20px"
          />
        </a>
      </div>
    </div>
    <hr />
    <div
      class="d-flex justify-content-around flex-wrap align-content-between my-3 intro"
    >
      <div>
        <img class="icons" src="./assets/html5.png" alt="html5" />
      </div>
      <div>
        <img class="icons" src="./assets/CSS.png" alt="css" />
      </div>
      <div>
        <img class="icons" src="./assets/JavaScript.png" alt="javascript" />
      </div>
      <div>
        <img class="icons" src="./assets/Sass.png" alt="javascript" />
      </div>
      <div>
        <img class="icons" src="./assets/Bootstrap.png" alt="bootstrap" />
      </div>
      <div>
        <img class="icons" src="./assets/Vue.png" alt="vue" />
      </div>
      <div>
        <img class="icons" src="./assets/Git.png" alt="git" />
      </div>
      <div>
        <img class="icons" src="./assets/Jira.png" alt="jira" />
      </div>
    </div>
    <hr />
    <!-- <div class="intro my-3">
      As far as my personality is concerned, I am a person who does not give up
      easily on my goals. The worst thing that can happen to me is to have a
      repetitive, boring job. I would definitely accept a less paid but mentally
      challenging job than a well-paid, administrative job. As long as a job has
      new challenges to be met, I could be dedicated. That being said, I also
      think that education should not stop with a formal degree. Moreover, I
      have been gaining new knowledge and skills since graduation. Also, I do
      not support the attitude where suggestions are labeled as criticism: when
      new skills are being learned, every information or advice are welcome.
    </div>
    <hr /> -->
    <div class="intro">
      <div class="education my-3">
        <ul>
          <strong>Education:</strong>
          <li>Vue.js library - VueMastery, VueSchool</li>
          <li>
            JavaScript Algorithms and Data Structures - freeCodeCamp, San
            Francisco, California (see
            <a
              href="https://www.freecodecamp.org/certification/CoderDecoderDev/javascript-algorithms-and-data-structures"
              target="_blank"
              >here</a
            >)
          </li>
          <li>The Web Developer Bootcamp by Colt Steele - Udemy</li>
          <li>BA in English Language and Literature and German Language</li>
          <li>
            <strong>Foreign languages:</strong> English: C2 (<a
              href="https://prnt.sc/gIjlbhXTywE4"
              target="_blank"
              >CELTA</a
            >, <a href="https://prnt.sc/W-RKTH2UMIsK" target="_blank">TEYL</a>),
            German: B2 (<a href="https://prnt.sc/AKZyHqDtDmAN" target="_blank"
              >Austrian Institute Certificate</a
            >)<br />
            <div>(Original documents will be provided at request.)</div>
          </li>
        </ul>
      </div>
      <hr />
      <h3 class="animate__animated animate__flash my-3">
        <strong>Here are some of my projects:</strong>
      </h3>
    </div>
    <div>
      <div class="card-group">
        <div class="row d-flex justify-content-center">
          <!-- To-do List App -->
          <div
            class="card col-md-4 col-lg-3 animate__animated animate__slideInUp"
          >
            <a href="https://todolist-mladenkvc.netlify.app/" target="_blank">
              <img
                class="card-img-top"
                src="./assets/ToDoList.jpg"
                alt="ToDoList image"
              />
            </a>
            <div class="card-body">
              <a href="https://todolist-mladenkvc.netlify.app/" target="_blank">
                <h5 class="card-title">To Do List App</h5>
                <p class="card-text">
                  In this project, I used Vue.js (v-on, v-model, v-bind, v-for,
                  v-if, computed, props, events, components, etc.) and
                  Bootstrap. The user can filter through the tasks using the
                  three buttons. Moreover, the task can be edited, marked as
                  finished, and finally deleted. There is a snack-bar warning
                  when no text is entered.
                </p>
              </a>
              <div>
                <a
                  href="https://todolist-mladenkvc.netlify.app/"
                  class="btn btn-primary m-1"
                  target="_blank"
                  >See Project</a
                >
              </div>
              <div>
                <a
                  href="https://github.com/CoderDecoderDev/ToDoList.git"
                  class="btn btn-success m-1"
                  target="_blank"
                  >See Code</a
                >
              </div>
            </div>
          </div>
          <!-- Dictionary App -->
          <div
            class="card col-md-4 col-lg-3 animate__animated animate__slideInUp animate__delay-1s"
          >
            <a
              href="https://dictionary-app-mladenkvc.netlify.app/"
              target="_blank"
            >
              <img
                class="card-img-top"
                src="./assets/Dictionary.png"
                alt="Dictionary image"
              />
            </a>
            <div class="card-body">
              <a
                href="https://dictionary-app-mladenkvc.netlify.app/"
                target="_blank"
              >
                <h5 class="card-title">Dictionary App</h5>
                <p class="card-text">
                  In this project, I used HTML, CSS, JavaScript, Vue.js,
                  Bootstrap, API. In this app, the user can look up a word, play
                  the button for the pronunciation, and toggle dark and light
                  modes. There is a warning if the input is empty or the word is
                  not found or misspelled.
                </p>
              </a>
              <div>
                <a
                  href="https://dictionary-app-mladenkvc.netlify.app/"
                  class="btn btn-primary m-1"
                  target="_blank"
                  >See Project</a
                >
              </div>
              <div>
                <a
                  href="https://github.com/CoderDecoderDev/dictionary-app.git"
                  class="btn btn-success m-1"
                  target="_blank"
                  >See Code</a
                >
              </div>
            </div>
          </div>
          <!-- Store App -->
          <div
            class="card col-md-4 col-lg-3 animate__animated animate__slideInUp animate__delay-2s"
          >
            <a
              href="https://store-app-mladenkvc.netlify.app/#/"
              target="_blank"
            >
              <img
                class="card-img-top"
                src="./assets/StoreApp.png"
                alt="Store app image"
              />
            </a>
            <div class="card-body">
              <a
                href="https://store-app-mladenkvc.netlify.app/#/"
                target="_blank"
              >
                <h5 class="card-title">Store App</h5>
                <p class="card-text">
                  In this project, I used Vue.js (e.g. map, filter, methods,
                  computed, etc.), API, VueX, Vue Router, and SCSS (variables,
                  mixin, partials, function, etc.). The filter method was used
                  to filter out the API data according to a category. The map
                  method was used to modify the original array from API in order
                  to toggle a description for each item separately. On other
                  pages, the customer can add items to a cart or click on the
                  picture or title in order to go to a different route with more
                  details about the product and a bigger picture (this is
                  achieved through VueRouter name and params). On the cart page,
                  the customer can increase or decrease the amount or completely
                  remove the item from the cart (VueX is used in this case).
                </p>
              </a>
              <div>
                <a
                  href="https://store-app-mladenkvc.netlify.app/#/"
                  class="btn btn-primary m-1"
                  target="_blank"
                  >See Project</a
                >
              </div>
              <div>
                <a
                  href="https://github.com/CoderDecoderDev/store-app.git"
                  class="btn btn-success m-1"
                  target="_blank"
                  >See Code</a
                >
              </div>
            </div>
          </div>
          <!-- Time Tracking Dashboard -->
          <div
            class="card col-md-4 col-lg-3 animate__animated animate__slideInUp animate__delay-3s"
          >
            <a
              href="https://time-tracking-mladenkvc.netlify.app/#/daily"
              target="_blank"
            >
              <img
                class="card-img-top"
                src="./assets/TimeTrackingDashboard.png"
                alt="Time Tracking Dashboard"
              />
            </a>
            <div class="card-body">
              <a
                href="https://time-tracking-mladenkvc.netlify.app/#/daily"
                target="_blank"
              >
                <h5 class="card-title">Time Tracking Dashboard</h5>
                <p class="card-text">
                  In this project, I used Vue Router, SCSS (variables, import,
                  etc.), and CSS grid (grid-template, repeat, auto-fit, minmax,
                  grid-auto-row) to present data from JSON.
                </p>
              </a>
              <div>
                <a
                  href="https://time-tracking-mladenkvc.netlify.app/#/daily"
                  class="btn btn-primary m-1"
                  target="_blank"
                  >See Project</a
                >
              </div>
              <div>
                <a
                  href="https://github.com/CoderDecoderDev/time-tracking-dashboard.git"
                  class="btn btn-success m-1"
                  target="_blank"
                  >See Code</a
                >
              </div>
            </div>
          </div>
          <!-- Ping Pong Score Keeper -->
          <div
            class="card col-md-4 col-lg-3 animate__animated animate__slideInUp animate__delay-4s"
          >
            <a
              href="https://score-keeper-mladenkvc.netlify.app/"
              target="_blank"
            >
              <img
                class="card-img-top"
                src="./assets/PingPong.jpg"
                alt="Table tennis image"
              />
            </a>
            <div class="card-body">
              <a
                href="https://score-keeper-mladenkvc.netlify.app/"
                target="_blank"
              >
                <h5 class="card-title">Table Tennis Score Keeper</h5>
                <p class="card-text">
                  In this project, vanilla Javascript was used. This app keeps
                  score for two players in ping pong. Using Bulma, when one
                  player wins, the buttons are disabled and the colors of the
                  winner and loser are changed to green and red respectively.
                </p>
              </a>
              <div>
                <a
                  href="https://score-keeper-mladenkvc.netlify.app/"
                  class="btn btn-primary m-1"
                  target="_blank"
                  >See Project</a
                >
              </div>
              <div>
                <a
                  href="https://github.com/CoderDecoderDev/ScoreKeeper.git"
                  class="btn btn-success m-1"
                  target="_blank"
                  >See Code</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
};
</script>

<style>
body {
  background-image: linear-gradient(
    to right,
    rgba(207, 128, 128, 0.7),
    rgba(187, 187, 68, 0.7)
  );
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  text-align: center;
  color: #2c3e50;
  margin: 20px 10px;
}
h1 {
  font-weight: 500;
  text-shadow: 6px 6px 7px #2c3e50;
}
h5 {
  font-weight: 700;
  text-shadow: 2px 2px 7px #2c3e50;
}
.intro {
  max-width: 900px;
  margin: 0 auto;
  align-items: center;
}
.social {
  position: relative;
  top: 80px;
  right: 20px;
}
hr {
  max-width: 900px;
  margin: 0 auto;
}
.card {
  margin: 5px;
  padding: 0px;
}
.card-img-top {
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}
.icons {
  width: 60px;
  height: 60px;
}
img.icons {
  margin: 10px;
}
.profile {
  border-radius: 50%;
}
li {
  text-align: left;
}
div > a {
  text-decoration: none;
  color: rgb(0, 0, 0);
}
div > a:hover {
  color: rgb(0, 0, 0);
}
.animate__animated.animate__flash {
  --animate-duration: 3s;
}

/* media query */
@media only screen and (max-width: 576px) {
  #app {
    font-size: 1.2rem;
  }
}
</style>
